import {useCreateOfferMutation} from '@dms/api/sales';
import {useFormNavigate} from '@dms/features/vehicle-forms-kit';
import {handleApiError} from '@dms/shared';

export const useCreatePurchaseVehicle = () => {
  const {isBusinessCaseReferrer, getReferrerId, getPurchaseTypeFromQuery} = useFormNavigate();

  const [createOffer] = useCreateOfferMutation();

  const attachToBusinessCase = async (createdVehicleId: string) => {
    if (!isBusinessCaseReferrer) {
      return;
    }

    const businessCaseId = getReferrerId();
    if (!businessCaseId) {
      return;
    }

    const purchaseType = (getPurchaseTypeFromQuery() ?? '').toUpperCase();

    const offerRequestBody =
      purchaseType === 'BROKERAGE'
        ? {vehicleToPurchaseBrokerageId: createdVehicleId}
        : {vehicleToPurchaseId: createdVehicleId};
    await createOffer({businessCaseId, offerRequestBody}).unwrap().catch(handleApiError);
  };

  return {attachToBusinessCase};
};
